import "../css/footer.css"
export default function Footer() {
 return (
  <div>
   <div className=" ">
    <footer className="text-center text-lg-start ">
     <section className="d-flex justify-content-between p-1 footer-section">
      <div className="me-5">
 
      </div>
      <div>
       <a href="-" className=" me-4">
        <i className="fab fa-facebook-f"></i>
       </a>
       <a href="-" className=" me-4">
        <i className="fab fa-twitter"></i>
       </a>
       <a href="-" className=" me-4">
        <i className="fab fa-google"></i>
       </a>
       <a href="-" className=" me-4">
        <i className="fab fa-instagram"></i>
       </a>
       <a href="-" className=" me-4">
        <i className="fab fa-linkedin"></i>
       </a>
       <a href="-" className=" me-4">
        <i className="fab fa-github"></i>
       </a>
      </div>
     </section>
     <section className="">
      <div className="container text-center text-md-start mt-5">
       <div className="row mt-3">

        <div className="col-md-2 col-lg-2 col-xl-2 mx-auto mb-4">

         <h6 className="text-uppercase fw-bold">Layanan Pelanggan</h6>
         <hr
          className="mb-4 mt-0 d-inline-block mx-auto garis"
         />
         <p>
          <a href="#!" className="link-footer">Bantuan</a>
         </p>
         <p>
          <a href="#!" className="link-footer">Metode Pembayaran</a>
         </p>
        </div>

        <div className="col-md-3 col-lg-2 col-xl-2 mx-auto mb-4">

         <h6 className="text-uppercase fw-bold">Kebijakan W-Shop</h6>
         <hr
          className="mb-4 mt-0 d-inline-block mx-auto garis"
         />
         <p>
          <a href="#!" className="link-footer">Tentang Kami</a>
         </p>
         <p>
          <a href="#!" className="link-footer">Kebijakan Privasi</a>
         </p>
        </div>

        <div className="col-md-4 col-lg-3 col-xl-3 mx-auto mb-md-0 mb-4">

         <h6 className="text-uppercase fw-bold">Ikuti Kami</h6>
         <hr
          className="mb-4 mt-0 d-inline-block mx-auto garis"
         />
         <p><img alt="" src={"/img/instagramBlack.png"}/> Instagram</p>
         <p><img alt="" src={"/img/twitterBlack.png"}/>  Twitter</p>
         <p><img alt="" src={"/img/facebookBlack.png"}/>  Facebook</p>
        </div>
       </div>
      </div>
     </section>

     <div className="text-center p-3 mt-3 mb-3 border-top">
     ©W-Shop 2023. Hak Cipta Dilindungi
     </div>

    </footer>
   </div>
  </div>
 );
}
